export const imageTypes = ['image/jpg', 'image/jpeg', 'image/png'];
